import { render, staticRenderFns } from "./SelectUnities.vue?vue&type=template&id=24092ec0"
import script from "./SelectUnities.vue?vue&type=script&lang=js"
export * from "./SelectUnities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports